/*
 * @Author: Fan
 * @Date: 2020-04-16 17:51:26
 * @description:
 * @LastEditors: Fan
 */
import baseAttribute from "../../../../form/src/common/component-base-attribute";
import { ControlAttributeType } from "../../../../form/typings";
import { formatterRequiredFormula, formatterValueToSetStatus } from "../../../../form/utils";
import i18n from "../../../i18n";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "labelVisible", "visible", "style", "tips", "widgetType"],
        },
        controller: {
            label: "控制属性",
            keys: [
                "defaultValue",
                "direction",
                "dataLinkage",
                "displaySetting"
            ],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: Object.assign({}, baseAttribute.widgetType, { value: i18n.t('dataitem.Radio').toString() }),
        dataItemType: Object.assign({}, baseAttribute.dataItemType, { value: i18n.t('dataitem.Radio').toString() }),
        // 显示条件
        displayFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "showRule",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        // 是否必填
        requiredFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "requiredRule",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterRequiredFormula,
            },
        },
        // 只读条件
        readonlyCondition: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "readonlyCondition",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        // 默认值
        defaultValue: {
            options: {
                regexps: {
                    maxLength: {
                        len: 200,
                        message: i18n.t('dataitem.ValidityErrTips', { num: 200 }).toString(),
                    },
                },
            },
        },
        // 选项
        options: {
            inputMethod: ControlAttributeType.Modal,
            attrType: "radioOption",
            inputComponent: () => import("../../../../form/src/common/components/biz-option-data-model2.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        dataLinkage: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/data-linkage2.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        direction: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                list: [
                    {
                        value: "horizontal",
                        label: i18n.t('dataitem.Horizontal').toString(),
                    },
                    {
                        value: "vertical",
                        label: i18n.t('dataitem.Portrait').toString(),
                    },
                ],
            },
        },
        // 显示设置
        displaySetting: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                list: [
                    {
                        value: "showSelected",
                        label: i18n.t('dataitem.TickOption').toString(),
                    },
                    {
                        value: "showAllOption",
                        label: i18n.t('dataitem.AllItems').toString(),
                    },
                ],
            },
        }
    },
};
